<script setup>
import { provide, ref, onMounted } from 'vue';
import SimActivationForm from '@components/simActivationForm/simActivationForm.vue';
import QrSection from '@components/simActivationForm/parts/qrSection.vue';
import SuccessSim from '@components/simActivationForm/parts/success-sim.vue';
import SuccessSimSwap from '@components/simActivationForm/parts/success-sim-swap.vue';
import SuccessEsim from './components/simActivationForm/parts/success-esim.vue';
import SuccessEsimNew from './components/simActivationForm/parts/success-esim-new.vue';

const response = ref({});
const phone = ref('');
const step = ref('initial');
const simIsPorted = ref(false);

const DEFINED_STEPS = {
    'initial': 'initial',
    'qr': 'qr',
    'success': 'success',
    'success-swap': 'success-swap',
    'success-esim': 'success-esim',
    'success-esim-new': 'success-esim-new',
}
 
const setStep = (data) => step.value = data;
const setPhone = (data) => phone.value = data;
const setResponse = (data, isPorting = false) => {
    response.value = data;
    simIsPorted.value = isPorting;
    switch(data.sim_type) {
        case 'sim':
            if(isPorting) {
                setStep(DEFINED_STEPS['success-swap'])
            } else {
                setStep(DEFINED_STEPS['success'])
            }
            break;
        case 'esim':
            if(isPorting) {
                setStep(DEFINED_STEPS['qr'])
            } else {
                setStep(DEFINED_STEPS['qr'])
            }
            break;
    }
};

provide('form', {
    DEFINED_STEPS,
    setStep,
    response,
    simIsPorted,
})

onMounted(() => {
    document.body.classList.remove('loading');
});
</script>

<template>
    <div class="activation-container">
        <SimActivationForm
            :setResponse="setResponse"
            :setPhone="setPhone" 
            v-if="step === 'initial'"
        />
        <QrSection
            :phone="phone"
            v-if="step === 'qr'" 
            :response="response"    
        />
        <SuccessSim :phone="phone" v-if="step === 'success'" />
        <SuccessSimSwap :phone="phone" v-if="step === 'success-swap'" />
        <SuccessEsim :phone="phone" v-if="step === 'success-esim'" />
        <SuccessEsimNew
            :phone="phone"
            :response="response"
            v-if="step === 'success-esim-new'"
        />
    </div>
</template>